import React from 'react';
import loadable from '@loadable/component';
import Loading from './Loading';


const LoadableSearch = loadable(
  () => import(/* webpackChunkName: "searchAutoSuggestions" */ './Lodable'),
);


const SearchAutoSuggestions = () => (
  <LoadableSearch fallback={<Loading />} />
);

export default SearchAutoSuggestions;
